import { render, staticRenderFns } from "./BestellingenIndex.vue?vue&type=template&id=6f332c2c&scoped=true&"
import script from "./BestellingenIndex.vue?vue&type=script&lang=js&"
export * from "./BestellingenIndex.vue?vue&type=script&lang=js&"
import style0 from "./BestellingenIndex.vue?vue&type=style&index=0&id=6f332c2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f332c2c",
  null
  
)

export default component.exports